import type { MedicalConditionsPageProps } from 'lib/queries/conditions';
import { Wrap } from '@leafwell/components';
import PageWrap from 'components/page-wrap';
import HeroConditions from 'components/hero-conditions';
import WysiwygContent from 'components/wysiwyg-content';
import ArticleJson from 'components/structured-data/article';
import { getMedicalConditionsPage } from 'lib/queries/conditions';
import ConditionsAlphabetical from 'components/conditions-alphabetical';

export const getStaticProps = async context =>
  await getMedicalConditionsPage(context);

export default function MedicalConditions(props: MedicalConditionsPageProps) {
  const {
    page: {
      id,
      title,
      content,
      date,
      modified,
      seo,
      acf: { hero, pageType },
    },
    conditions,
  } = props;

  return (
    <PageWrap seo={seo} pageType={pageType} title={title}>
      <ArticleJson id={id} date={date} modified={modified} seo={seo} />
      <HeroConditions
        title={hero.title}
        subTitle={hero.subTitle}
        image={hero.image}
      />
      {content ? (
        <Wrap size="small" className="justify-items-center">
          <WysiwygContent className="w-full max-w-2xl" content={content} />
        </Wrap>
      ) : null}
      <ConditionsAlphabetical conditions={conditions} />
    </PageWrap>
  );
}
